import React, { Component } from 'react';
import Fade from 'react-reveal/Fade';
import Slider from 'react-slick';

class Team extends Component {
	render() {
		const settings = {
			dots: true,
			infinite: true,
			speed: 500,
			slidesToShow: 5,
			slidesToScroll: 2,
			responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 3,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            initialSlide: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
		};
		return (
			<div>
				<section id="team" className="section" name="scroll-to-team">
					<div className="container team">
						<div className="content is-centered has-text-centered ">
							<Fade left cascade>
								<h2 className="title is-uppercase">Testimoni</h2>
								<p className="subtitle">Apa kata mereka tentang Deliv?</p>
							</Fade>
						</div>
						<div className="columns">

						</div>
						<Slider {...settings}>
							<div className="column">
								<div className="card">
									<div className="card-image">
										<figure className="image is-square">
											<img
												src="https://bulma.io/images/placeholders/1280x960.png"
												alt="Placeholder image"
											/>
										</figure>
									</div>
									<div className="card-content">
										<div className="media">
											<div className="media-content has-text-centered">
												<p className="title is-5">Rahmat Arief H </p>
												<p className="subtitle is-6">Pengusaha</p>
											</div>
										</div>
										<div className="content has-text-centered">
											<i className="fas fa-quote-left"></i>	 Kalau boleh jujur, pengemudi Deliv ini ramah, sopan dan selalu berkendara sesuai aturan. Enggak asal asalanlah pokoknya!<br/><i className="fas fa-quote-right"></i>
											<br />
										</div>
									</div>
								</div>
							</div>
							<div className="column">
								<div className="card">
									<div className="card-image">
										<figure className="image is-square">
											<img
												src="https://bulma.io/images/placeholders/1280x960.png"
												alt="Placeholder image"
											/>
										</figure>
									</div>
									<div className="card-content">
										<div className="media">
											<div className="media-content has-text-centered">
												<p className="title is-5">Nugra Agung P</p>
												<p className="subtitle is-6">Pegawai Negeri</p>
											</div>
										</div>
										<div className="content has-text-centered">
											<i className="fas fa-quote-left"></i>	 Ngantor jadi enggak telat. Jadi tinggal pesen, beberapa menit udah sampai di rumah<br/><i className="fas fa-quote-right"></i>
											<br />
										</div>
									</div>
								</div>
							</div>
							<div className="column">
								<div className="card">
									<div className="card-image">
										<figure className="image is-square">
											<img
												src="/img/team/reksa-min.JPG"
												alt="Placeholder image"
											/>
										</figure>
									</div>
									<div className="card-content">
										<div className="media">
											<div className="media-content has-text-centered">
												<p className="title is-5">Reksa Rangga W</p>
												<p className="subtitle is-6">Dosen</p>

											</div>
										</div>
										<div className="content has-text-centered">
											<i className="fas fa-quote-left"></i>		Karya anak bangsa ini! Pengen kesana, ada De Ride, pengen naik mobil, ada De Car . Kalau laper ya De Food. Cepet deh.<br/><i className="fas fa-quote-right"></i>
										</div>
									</div>
								</div>
							</div>
							<div className="column">
								<div className="card">
									<div className="card-image">
										<figure className="image is-square">
											<img
												src="/img/team/rofiqo2.jpg"
												alt="Placeholder image"
											/>
										</figure>
									</div>
									<div className="card-content">
										<div className="media">
											<div className="media-content has-text-centered">
												<p className="title is-5">Rofiqo Fauzan F</p>
												<p className="subtitle is-6">Karyawan</p>

											</div>

										</div>
										<div className="content has-text-centered">
											<i className="fas fa-quote-left"></i>	Udah keburu laper, trus pengen pesen makan gak pakek ribet dan gak mahal di ongkir. Ya udah pakai Deliv aja!<br/><i className="fas fa-quote-right"></i>
										</div>
									</div>
								</div>
							</div>
							<div className="column">
								<div className="card">
									<div className="card-image">
										<figure className="image is-square">
											<img
												src="/img/team/naufaldi.JPG"
												alt="Placeholder image"
											/>
										</figure>
									</div>
									<div className="card-content">
										<div className="media">
											<div className="media-content has-text-centered">
												<p className="title is-5">Naufaldi Rafif</p>
												<p className="subtitle is-6">Mahasiswa</p>

											</div>
										</div>
										<div className="content has-text-centered">
											<i className="fas fa-quote-left"></i>	Cepet dapet driver, cepet nyampek dan harga yang pas buat mahasiswa!<br/><i className="fas fa-quote-right"></i>
										</div>
									</div>
								</div>
							</div>
							<div className="column">
								<div className="card">
									<div className="card-image">
										<figure className="image is-square">
											<img
												src="/img/team/adwi.png"
												alt="Adwi Arifin"
											/>
										</figure>
									</div>
									<div className="card-content">
										<div className="media">
											<div className="media-content has-text-centered">
												<p className="title is-5">Adwi Arifin</p>
												<p className="subtitle is-6">Guru</p>

											</div>

										</div>
										<div className="content has-text-centered">
											<i className="fas fa-quote-left"></i>	Aplikasi Deliv enggak makan memory banget. Trus mudah juga penggunaannya. Ayah saya pakek pun bisa kok!
											<br/>
											<i className="fas fa-quote-right"></i>
										</div>
									</div>
								</div>
							</div>
						</Slider>


					</div>
				</section>
			</div>
		);
	}
}

export default Team;
